// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.color-sample-combinations {\n  width:100%;\n}\n.color-sample-combinations .card-item.color-card-item .inner .color-card-detail .inline-extra-icon{\n  width:100%;\n}\n.color-sample-combinations .color-card-detail .inline-extra-icon .addtoCartButton i{\n  line-height:1;\n  font-size:24px;\n  position:relative;\n  top:-3px;\n  color:#e2001a;\n}\n", ""]);
// Exports
module.exports = exports;
